// @flow
import { InvoicesActionTypes } from './constants';

type InvoicesAction = { type: string, payload: {} | string };

// common success
export const invoicesApiResponseSuccess = (actionType: string, data: any): InvoicesAction => ({
    type: InvoicesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const invoicesApiResponseError = (actionType: string, error: string): InvoicesAction => ({
    type: InvoicesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const listInvoicesByClient = (contactoId:string): InvoicesAction => ({
    type: InvoicesActionTypes.LIST_INVOICES_BY_CLIENT,
    payload: {contactoId},
});


export const resetInvoices = (): InvoicesAction => ({
    type: InvoicesActionTypes.RESET,
    payload: {},
});

